import { Messages } from '../../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { IDatasourceActions } from '../../../../ts/ServerApi/types/IDatasourceActions';
import { IWorkbookActions } from '../../../../ts/ServerApi/types/IWorkbookActions';
import { changeExtractRefreshSchedule } from '../../../actions/spaces/ChangeExtractRefreshScheduleAction';
import { selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../state/AppState';
import { hasExtractRefreshPermission } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const ChangeExtractRefreshScheduleEntityAction:
    IEntityAction<IExtractTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksChangeSchedule,
  translateName: Messages.changeFrequency_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: changeExtractRefreshSchedule
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IExtractTaskInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return hasExtractRefreshPermission(state, spaceItem, availableActions);
}
